import { use } from 'react'
import { useIntl } from '@/intl'
import MultiSelectPricesFilter, {
  mapLocalSelectionToGA4Result,
} from '@/scopes/prices/components/Filters/MultiSelectPricesFilter'
import {
  participantsSelector,
  roomTypeFilterOptionsSelector,
} from '@/scopes/prices/components/selectors'
import { createPricesFilterClickEvent } from '@/scopes/prices/domain/analytics'
import { FiltersInPricesValues, Option } from '@/scopes/prices/domain/filters/types'
import { PricesActionsContext } from '@/scopes/prices/domain/PricesActionsContext'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'

interface RoomTypeFilterProps {
  isFlightOnly: boolean
}

function RoomTypeFilter({ isFlightOnly = false }: RoomTypeFilterProps) {
  const intl = useIntl()
  const { selectFilter } = use(PricesActionsContext)
  const { selectedValues: Participants } = usePricesSelector(participantsSelector)

  const { options, selectedValues } = usePricesSelector(roomTypeFilterOptionsSelector)
  const setSelection = (selection: FiltersInPricesValues) => selectFilter({ type: 'RoomType', selection })

  if (isFlightOnly) {
    return null
  }

  if (Participants && Participants?.length > 1) {
    return null
  }

  return (
    <MultiSelectPricesFilter
      options={options}
      selectedValues={selectedValues}
      setSelection={setSelection}
      label={intl.formatMessage({ id: 'prices_filters_roomtype_label' })}
      placeholder={intl.formatMessage({ id: 'prices_filters_roomtype_placeholder' })}
      confirmButton={intl.formatMessage({ id: 'prices_filters_roomtype_confirm_button' })}
      analyticsEventBuilder={(selection: string | string[] | undefined, options: Option[]) => {
        return createPricesFilterClickEvent({
          element: 'dropdown',
          type: 'roomType',
          result: mapLocalSelectionToGA4Result(selection, options),
        })
      }}
    />
  )
}

export { RoomTypeFilter }
